import React, { useState } from 'react';
import {
  Container,
  Navbar,
  NavbarBrand,
  Nav,
  NavItem,
  Button,
} from 'reactstrap';
import Modal from '../Common/Modal/Modal';
import EditAcquisitionOrders from './EditAcquisitionOrders';

import { useTranslation } from 'react-i18next';

const BatchUserBar = ({ users, selectedUserIds }) => {
  const [editAcquisitionOrdersModal, setEditAcquisitionOrdersModal] =
    useState(false);

  users = users.filter(({ id }) => selectedUserIds.includes(id));
  const { t } = useTranslation();

  return (
    <>
      <div
        className={`fixed-bottom ${
          selectedUserIds.length ? 'visible' : 'invisible'
        }`}>
        <Navbar style={{ backgroundColor: '#2a3042' }} dark expand="md">
          <Container style={{ justifyContent: 'flex-start' }}>
            <NavbarBrand>{t('Manage')}:</NavbarBrand>
            <Nav pills>
              <NavItem>
                <Button
                  color="info"
                  outline
                  className="waves-effect waves-light"
                  onClick={() => setEditAcquisitionOrdersModal(true)}>
                  <i
                    className={`bx bx-wallet font-size-20 align-middle mr-2`}></i>
                  {t('Edit Acquisition Orders')}
                </Button>
              </NavItem>
            </Nav>
          </Container>
        </Navbar>
      </div>
      <Modal
        size="xl"
        title="Edit Acquisition Orders"
        isOpen={editAcquisitionOrdersModal}
        toggle={() =>
          setEditAcquisitionOrdersModal(!editAcquisitionOrdersModal)
        }
        showClose
        scrollable={false}>
        <EditAcquisitionOrders users={users} />
      </Modal>
    </>
  );
};

export default BatchUserBar;
